module.exports = __webpack_public_path__ + "static/fi_home-ddeacb46421fe85ad8ad211214136f6f.png";